import useSelectCustomFieldValueForKeyAndType from './useSelectCustomFieldValueForKeyAndType'

export default function useSelectFullName() {
  const firstName = useSelectCustomFieldValueForKeyAndType(
    'contact_first_name',
    'CONTACT'
  )
  const lastName = useSelectCustomFieldValueForKeyAndType(
    'contact_last_name',
    'CONTACT'
  )

  return `${firstName || ''}${firstName && lastName ? ' ' : ''}${lastName ||
    ''}`
}
